import { render, staticRenderFns } from "./TimeAgo.vue?vue&type=template&id=6ba795c3&scoped=true&"
import script from "./TimeAgo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TimeAgo.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba795c3",
  null
  
)

export default component.exports